document.querySelector("html").classList.remove("no-js");

const body = document.querySelector("body");
const html = document.querySelector("html");
const mq = window.matchMedia("(min-width: 800px)");
// Widths
const px800 = window.innerWidth <= 800;
const togglePopoverSupported = typeof body.hidePopover === "function";

if (togglePopoverSupported) {
  isPopoverSupported = true;
} else {
  html.classList.add("no-popover");
  isPopoverSupported = false;
}
// // console.log("Popover supported:", isPopoverSupported);

const indexCheck = document
  .querySelector("body")
  .classList.contains("template-index");
const productCheck = document
  .querySelector("body")
  .classList.contains("template-product");
const bridalCheck = document
  .querySelector("body")
  .classList.contains("suffix-bridal"); 
const collectionCheck = document
  .querySelector("body")
  .classList.contains("template-collection"); 
const searchCheck = document
  .querySelector("body")
  .classList.contains("template-search");
const blogCheck = document
  .querySelector("body")
  .classList.contains("template-blog");
const annBarCheck = document.querySelector(".announcement-bar") !== null;

const formCheck = document.getElementById("add-to-cart-form") !== null;
const qtyCheck = document.querySelector(".js-quantity-picker") !== null;
const lineQtyCheck = document.querySelector("quantity-selector") !== null;
const instaCheck = document.querySelector(".section-instagram-feed") !== null;
const gridSectionCheck = document.querySelector(".grid-slider") !== null;
const sizeGuideCheck = document.querySelector(".size-guide__link") !== null;

function debounce(func, wait) {
  let timeout;
  return function (...args) {
    const context = this;
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(context, args), wait);
  };
}

if (
  navigator.userAgent.indexOf("Safari") != -1 &&
  navigator.userAgent.indexOf("Chrome") == -1
) {
  body.classList.add("browser-safari");
}

// Reccomendations
// function reccs() {
//   const productRecommendationsSection = document.querySelector(
//     "section.recommendations",
//   );

//   if (!productRecommendationsSection) return;

//   const handleIntersection = (entries, observer) => {
//     if (!entries[0].isIntersecting) return;

//     observer.unobserve(productRecommendationsSection);

//     const url = productRecommendationsSection.dataset.url;

//     fetch(url)
//       .then((response) => response.text())
//       .then((text) => {
//         const html = document.createElement("div");
//         html.innerHTML = text;
//         const recommendations = html.querySelector(".recommendations");

//         if (recommendations && recommendations.innerHTML.trim().length) {
//           productRecommendationsSection.innerHTML = recommendations.innerHTML;
//           // Dispatch custom event
//           document.dispatchEvent(new CustomEvent("recommendationsLoaded"));
//         }
//       })
//       .catch((e) => {
//         console.error(e);
//       });
//   };

//   const observer = new IntersectionObserver(handleIntersection, {
//     rootMargin: "0px 0px 200px 0px",
//   });

//   observer.observe(productRecommendationsSection);
// }

// if (productCheck) {
//   reccs();
// }


// Intersection Observer
function intObs() {
  if (typeof IntersectionObserver === "undefined") return;

  let observerSelector = ".observed",
    observerObject = document.querySelectorAll(observerSelector),
    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          entry.target.classList.add("observer-ready");

          if (entry.intersectionRatio >= 0.1) {
            entry.target.classList.add("in-view");
            entry.target.classList.remove("out-of-view");
            if (entry.intersectionRatio > 0.5) {
              setTimeout(() => {
                entry.target.classList.add("viewed-once");
              }, 3000);
            }
          } else {
            entry.target.classList.remove("in-view");
            entry.target.classList.add("out-of-view");
          }
        });
      },
      {
        threshold: [0, 0.1, 1],
      },
    );

  observerObject.forEach((holder) => {
    observer.observe(holder);
  });

  window.addEventListener("resize", function () {
    observerObject.forEach((holder) => {
      observer.observe(holder);
    });
  });
}

intObs();

if (Shopify.designMode) {
  document.addEventListener("shopify:section:load", function () {
    intObs();
  });
}

if (Shopify.designMode) {
  document.addEventListener("shopify:section:load", function () {
    intObsMobile();
  });
}

let isMiniCartOpen = false,
  wasTransparent = false;
function closeMenu() {
  if (isPopoverSupported) {
    document.getElementById("mobile-menu").hidePopover();
  } else {
    document.querySelector("html").classList.remove("menu-active");
  }
}

function onMenuItemClick(event) {
  let menuItems = document.querySelectorAll("nav .mobile-menu__link");

  menuItems.forEach((item) => {
    item.addEventListener("click", function (event) {
      href = item.getAttribute("href");
      if (href && href.startsWith("#")) {
        // console.log("menu item clicked");
        closeMenu();
      }
    });
  });
}

// On Mini Cart Click
class MiniCart {
  constructor(target) {
    if (isPopoverSupported) {
      document
        .querySelector(".mini-cart")
        .addEventListener("beforetoggle", this.onMiniCartToggle.bind(this));
    } else {
      target.addEventListener("click", this.onMiniCartClick.bind(this));
    }
  }

  statusClasses() {
    let htmlEl = document.querySelector("html"),
      cartCheck = htmlEl.classList.contains("mini-cart-open"),
      mobileMenuCheck = htmlEl.classList.contains("menu-active"),
      emptyCartCheck = document
        .querySelector(".mini-cart .cart-contents")
        .classList.contains("cart-contents--empty");

    if (mobileMenuCheck) {
      htmlEl.classList.remove("menu-active");
      htmlEl.classList.add("mini-cart-open");
    } else if (!cartCheck) {
      htmlEl.classList.add("mini-cart-open");
    } else {
      htmlEl.classList.remove("mini-cart-open");
    }
  }

  onMiniCartToggle(event) {
    let htmlEl = document.querySelector("html"),
      header = document.querySelector("header.main-header");

    // Check the state of the header before handling the event
    if (isHeaderTransparent) {
      wasTransparent = true;
    } else {
      wasTransparent = false;
    }

    if (event.newState === "open") {
      this.statusClasses();
      htmlEl.classList.add("mini-cart-open");
      document.querySelector(".mini-cart").classList.add("open");
      isMiniCartOpen = true;
      if (wasTransparent) {
        header.classList.remove("transparent--visible");
      }
    } else {
      this.statusClasses();
      htmlEl.classList.remove("mini-cart-open");
      document.querySelector(".mini-cart").classList.remove("open");
      isMiniCartOpen = false;
      if (wasTransparent) {
        header.classList.add("transparent--visible");
      }
    }
  }

  onMiniCartClick(event) {
    let htmlEl = document.querySelector("html"),
      header = document.querySelector("header.main-header");

    // Check the state of the header before handling the event
    if (isHeaderTransparent) {
      wasTransparent = true;
    } else {
      wasTransparent = false;
    }

    if (!htmlEl.classList.contains("mini-cart-open")) {
      this.statusClasses();
      htmlEl.classList.add("mini-cart-open");
      document.querySelector(".mini-cart").classList.add("open");
      isMiniCartOpen = true;
      if (wasTransparent) {
        header.classList.remove("transparent--visible");
      }
    } else {
      this.statusClasses();
      htmlEl.classList.remove("mini-cart-open");
      document.querySelector(".mini-cart").classList.remove("open");
      isMiniCartOpen = false;
      if (wasTransparent) {
        header.classList.add("transparent--visible");
      }
    }
  }
}

class MobileMenu {
  constructor(target) {
    this.target = target;
    this.eventListenerAdded = false;
    this.addEventListener();
  }

  addEventListener() {
    if (!this.eventListenerAdded) {
        // console.log("Event listener added");
        this.target.addEventListener(
          "click",
          debounce(this.onMenuClick.bind(this)),
        );
      }
      this.eventListenerAdded = true;
    }
  

  onMenuClick(event) {
    if (!html.classList.contains("menu-active")) {
     document.querySelector("html").classList.add("menu-active");
      // console.log("Menu has been shown");
      onMenuItemClick(event);
    } else {
      document.querySelector("html").classList.remove("menu-active");
      // console.log("menu has been hidden");
    } 
  }
}
function getScrollbarWidth() {
  return window.innerWidth - document.documentElement.clientWidth;
}
function mobileMenuClass() {
  let menuLink = document.querySelector("button.js-menu"),
      html = document.querySelector("html");

      if (!mq.matches) {
        menuLink = document.querySelector('button.js-menu.header-mobile__burger')
      } else {
        menuLink = document.querySelector('button.js-menu.header-desktop__burger')
      }

  if (!menuLink.dataset.listenerAdded) {
    const menuClickHandler = function (event) {
      const scrollbarWidth = getScrollbarWidth();
      if (html.classList.contains("menu-active")) {
        // document.documentElement.style.paddingRight = ""
        html.classList.remove("menu-active");
        this.setAttribute("aria-expanded", "false");
        document.removeEventListener('click', clickOutsideMenu);
        // Remove listener and re-add after a short delay to avoid immediate reopen
        menuLink.removeEventListener("click", menuClickHandler);
        setTimeout(() => {
          delete menuLink.dataset.listenerAdded;
          mobileMenuClass();
        }, 400); // 400ms delay to prevent immediate reopen
      } else {
        // document.documentElement.style.paddingRight = scrollbarWidth + "px";
        setTimeout(() => {
          html.classList.add("menu-active");
          this.setAttribute("aria-expanded", "true");
          document.addEventListener('click', clickOutsideMenu);
        }, 200);
      }
    };
    menuLink.addEventListener("click", menuClickHandler);
    menuLink.dataset.listenerAdded = "true";
  } 
}

function clickOutsideMenu(event) {
  if (mq.matches) {
    var menu = document.getElementById('mobile-menu')
    if (!menu.contains(event.target)) {
       html.classList.remove("menu-active");
    }
  }
}

function onSearchClick(search) {
  search.addEventListener("click", function (event) {
    if (html.classList.contains("search-active")) {
      html.classList.remove("search-active");
    } else {
      html.classList.add("search-active");
      let searchInput = document.querySelector(".js-search-input");

      if (searchInput) {
        searchInput.focus();
      }
    }
  });
}

let searchLinks = document.querySelectorAll(".js-search");

// Search Form
class SearchForm {
  constructor(target) {
    target.addEventListener("keyup", this.onSearchInputKeyUp.bind(this));
  }

  onSearchInputKeyUp(event) {
    let form = event.target.closest("form"),
      button = form.querySelector(".js-search-submit"),
      shouldDisableButton = event.target.value.length === 0;

    // console.log(shouldDisableButton);

    if (shouldDisableButton) {
      button.setAttribute("disabled", true);
      button.classList.add("btn-disabled");
      button.classList.add("opacity-025");
    } else {
      button.classList.remove("btn-disabled");
      button.classList.remove("opacity-025");
      button.removeAttribute("disabled");
    }
  }
}

const productGrid = document.getElementById("product-grid");
const articleGrid = document.getElementById("blog-grid");

function infScroll(container, append) {
  let parent = container.parentNode,
    pagination = parent.querySelector(".pagination"),
    viewMore = document.querySelector(".view-more");

  if (pagination !== null) {
    // console.log("pagination exists");

    let infScrollActive = pagination.getAttribute("data-inf-scroll");

    if (infScrollActive === "true") {
      // console.log("infinite scroll active");

      let viewMoreText = viewMore.querySelector(".view-more__button");
      viewMore.classList.remove("visually-hidden"); // show view more button
      // console.log("display view more button");

      infiniteScroll = new InfiniteScroll(container, {
        // options
        hideNav: ".pagination",
        scrollThreshold: false,
        path: ".pagination__step.next",
        append: append,
        // history: true,
        // historyTitle: true,
        button: ".view-more__button",
        scrollThreshold: false,
        onInit: function () {
          this.on("load", function () {
            // console.log("Infinite Scroll load");
          });
          this.on("request", function () {
            // console.log("Infinite Scroll request");
            viewMoreText.textContent = "Loading…";
          });
          this.on("append", function (body, path, items, response) {
            // console.log("Infinite Scroll append path - " + path);
            // console.log("Infinite Scroll append length - " + items.length);
            // console.log("Infinite Scroll append response - " + response.status);
            intObs();
            viewMoreText.textContent = "View More";
          });
          this.on("error", function () {
            // console.log("Infinite Scroll error");
          });
        },
      });
    } else {
      // console.log("infinite scroll disabled in settings");
      return;
    }
  } else {
    // console.log("no pagination");
  }
}

function infScrollReset() {
  // console.log("reset inf scroll");
  let append = "li.product-card";

  if (typeof infiniteScroll !== "undefined" && infiniteScroll !== null) {
    infiniteScroll.destroy();
  } else {
    // console.log("infiniteScroll is not defined");
    return;
  }

  if (productGrid) {
    // console.log("product grid");
    let latestProductGrid = document.querySelector(
      "#ProductGridContainer #product-grid",
    );
    append = "li.product-card";
    infScroll(latestProductGrid, append);
  } else if (articleGrid) {
    // console.log("article grid");
    let latestArticleGrid = document.querySelector("#article-grid");
    append = "li.article-card";
    infScroll(latestArticleGrid, append);
    intObs();
  } else {
    // console.log("no grids");
  }
}

// Announcement Bar
function annBar() {
  let annBar = document.querySelector(".announcement-bar"),
    annClose = document.querySelector(".announcement-bar .js-close"),
    slider = document.querySelector(".announcement-bar__carousel"),
    html = document.querySelector("html"),
    bannerCheck = html.classList.contains("show-banner");

  if (sessionStorage.hasOwnProperty("annHide")) {
    // console.log("banner previously hidden");
    html.classList.remove("show-banner");
    annBar.style.display = "none";
  } else {
    if (bannerCheck) {
      // html.classList.add('show-banner')
      // // console.log("banner already showing");

      if (slider) {
        var flkty = new Flickity(slider, {
          wrapAround: true,
          prevNextButtons: false,
          cellSelector: ".announcement-bar__cell",
          autoPlay: 4000,
          pageDots: false,
          setGallerySize: false,
          draggable: false,
          fade: true,
        });
      }

      annClose.addEventListener("click", function (event) {
        event.preventDefault();

        html.classList.remove("show-banner");
        annBar.style.display = "none";

        window.sessionStorage.setItem("annHide", "true");
        window.sessionStorage.setItem("origin", "https://cawleystudio.com");
      });
    }
  }
}

function debounce(func, wait) {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
}

// Hero Carousel
let homeFlkty;

function heroCarousel(slider) {
  homeFlkty = new Flickity(slider, {
    wrapAround: true,
    prevNextButtons: false,
    cellSelector: ".home__carousel__item",
    autoPlay: false,
    pageDots: false,
    draggable: false,
    fade: true,
  });

  if (!mq.matches) {
    // console.log("show counter");

    let counter = document.querySelector(".home__carousel__counter"),
      currentCounter = counter.querySelector(".js-carousel__index");

    homeFlkty.on("change", function (index) {
      // console.log("Flickity index " + index);
      currentCounter.textContent = index + 1;
    });
  }
}

const heroCarouselEl = document.querySelector(
  "ul.home__carousel.carousel--enabled",
);
const heroCarouselCheck = heroCarouselEl !== null;



function homeScrollSnapCounter() {
  // when product image is in viewport, update counter to reflect index.
  // use IntersectionObserver to detect when product image is in viewport, change the counter to reflect the index of the image (data-image).

  const gallery = document.querySelector(".home__carousel");

  if (!gallery) return;

  let media = gallery.querySelectorAll(".home__carousel__item--image"),
    counterTotal = document.querySelector(
      ".home__carousel__counter .js-carousel__index",
    );

  if (gallery === null || !counterTotal ) {
    return
  }

  let observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.intersectionRatio >= 0.75) { // Adjust threshold as needed
        let index = entry.target.getAttribute("data-index")

      
        console.log("index", index);
        counterTotal.textContent = index;
      }
    });
  }, {
    threshold: [0.75] // Adjust threshold as needed
  });

  media.forEach((image) => {
    observer.observe(image);
  });
}


function homeHero() {
  const homeCarousel = document.querySelector(".home__carousel");
  const homeList = document.querySelector(".home__list");
   const homeListItems = document.querySelectorAll(".home__list__item");

  if (!homeCarousel || !homeList) return;
  let allowScrollBelow = false;
  // Prevent default scrolling on the carousel and control the list's scroll
  function carouselScroll(event) {
    homeCarousel.addEventListener("wheel", function (event) {
      if (allowScrollBelow) return;
      event.preventDefault(); // Stop the default scroll behavior of the carousel
  
      // Scroll the home__list element vertically
      homeList.scrollBy({
        top: event.deltaY, // Use the vertical scroll delta from the wheel event
      });
  
      // Check if the user has reached the end of the home__list scroll
      const maxScrollTop = homeList.scrollHeight - homeList.clientHeight;
      if (homeList.scrollTop >= maxScrollTop && event.deltaY > 0) {
        allowScrollBelow = true; // Allow scrolling below the carousel
        // console.log("allowScrollBelow", allowScrollBelow);
      }
    });
  
      // Reset allowScrollBelow when scrolling back up to the top
      homeCarousel.addEventListener("scroll", function () {
        if (homeCarousel.scrollTop === 0) {
          allowScrollBelow = false; // Reset to prevent scrolling below the carousel
          // console.log("allowScrollBelow reset to", allowScrollBelow);
        }
      });
  }
  carouselScroll();
// Intersection Observer to detect when .home__carousel is fully back in the viewport
  const carouselObs = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && entry.intersectionRatio === 1) {
          allowScrollBelow = false; // Reset allowScrollBelow
          // console.log("home__carousel fully back in viewport, allowScrollBelow reset to", allowScrollBelow);
          carouselScroll(); // Call the reset function
        }
      });
    },
    {
      threshold: 1.0, // Trigger only when the entire element is visible
    }
  );

// Observe the home__carousel element
carouselObs.observe(homeCarousel);
  // Intersection Observer to sync home__list__item with Flickity slides
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const index = entry.target.getAttribute("data-index");
          homeFlkty.select(parseInt(index) - 1); // Flickity uses zero-based indexing
        }
      });
    },
    {
      root: homeList, // Observe within the home__list container
      threshold: 0.5, // Trigger when 50% of the item is visible
    }
  );

  // Observe each home__list__item
  homeListItems.forEach((item) => {
    observer.observe(item);
  });
} 


// Product Tabs

function productTabs() {
  let tabs = document.querySelectorAll(".product-main__info__nav--link")
      

  tabs.forEach((tab) => {
    tab.addEventListener("click", function (event) {
      event.preventDefault();
      if (tab.classList.contains("active")) {
        return;
      } else {
        tabs.forEach((tab) => {
          tab.classList.remove("active");
        });
        tab.classList.add("active");
        
        let tabParent = tab.parentNode,
            tabTarget = tabParent.getAttribute("data-target"),
            tabContentActive = document.querySelector("." + tabTarget + ".product-main__tertiary"),
            tabContentEls = document.querySelectorAll('.product-main__tertiary');

        tabContentEls.forEach((el) => {
          el.classList.remove("active");
        });

        tabContentActive.classList.add("active");
      }
    });
  });
}

function productScrollSnapCounter() {
  // when product image is in viewport, update counter to reflect index.
  // use IntersectionObserver to detect when product image is in viewport, change the counter to reflect the index of the image (data-image).

  if (bridalCheck) {
    console.log("Bridal, no counter");
    return;
  } else {
    let gallery = document.querySelector(".product-main__gallery"),
      media = gallery.querySelectorAll(".gallery-media"),
      counter = document.querySelector(
        ".product-main__gallery__counter .js-carousel__index",
      );

    if (gallery === null || !counter) {
      console.log("No gallery or counter");
      return;
    }

    let observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.intersectionRatio >= 0.75) {
            // Adjust threshold as needed
            let index = entry.target.getAttribute("data-index");
            console.log("index", index);
            counter.textContent = index;
          }
        });
      },
      {
        threshold: [0.75], // Adjust threshold as needed
      },
    );

    media.forEach((image) => {
      observer.observe(image);
    });
  }

}



function bridalHero() {
  if (mq.matches && bridalCheck) {
    // console.log("Desktop, hero visible");
    // Ensure GSAP and ScrollTrigger are loaded
    gsap.registerPlugin(ScrollTrigger);
    
      // Select the first and third images
    
      const firstImage = document.querySelector(".bridal__hero-image--index-1");
      const thirdImage = document.querySelector(".bridal__hero-image--index-3");

      const rootStyles = getComputedStyle(document.documentElement);
  
      gsap.timeline({
        scrollTrigger: {
          trigger: ".bridal__hero", // Element that triggers the animation
          start: 'top', // Start animation when the top of the trigger element hits the top of the viewport
          // end: "bottom bottom", // End animation after scrolling 100% of element's height 
          scrub: false, // Add a slight delay to the scroll trigger
          // pinSpacing: false,
          once: true
        }
      }) 
      .to(firstImage, { x: "0%", duration: 2, ease: "power1.out",  }) // Move the first image out to the left
      .to(thirdImage, { x: "0%", duration: 2, ease: "power1.out",  }, "<"); // Move the third image out to the right
    
    
    } else {
      // console.log("Mobile or not bridal, hero hidden");
      return
    }
}

let bridalFlkty

function bridalCarousel() {
  if (mq.matches && bridalCheck) {
    // Initialize Flickity only if it hasn't been initialized yet
    if (!bridalFlkty) {
      const slider = document.querySelector(".product-main__gallery--bridal");
      const cellSelector = ".gallery-media";
      const cellEls = document.querySelectorAll(cellSelector);

      if (!slider) {
        console.error("Slider element not found.");
        return;
      }

      bridalFlkty = new Flickity(slider, {
        wrapAround: true,
        prevNextButtons: false,
        cellSelector: ".gallery-media",
        autoPlay: false,
        pageDots: false,
        draggable: false,
        fade: true,
      });

      const counter = document.querySelector(".product-main__gallery__counter");
      const currentCounter = counter.querySelector(".js-carousel__index");

      cellEls.forEach((cell) => {
        cell.addEventListener("click", function () {
          bridalFlkty.next(true, false);
        });
      });

      bridalFlkty.on("change", function (index) {
        // console.log("Flickity index " + index);
        currentCounter.textContent = index + 1;
      });

      // console.log("Flickity instance initialized.");
    }
  } else if (bridalCheck && !mq.matches) {
    // Destroy Flickity instance if it exists
    if (bridalFlkty) {
      bridalFlkty.destroy();
      bridalFlkty = null; // Reset the variable to ensure it can be reinitialized later
      // console.log("Flickity instance destroyed.");
    }
    // console.log("Mobile or not bridal, hero hidden.");
  }
}



//  Collection / Search scripts

collectionScripts = () => {
  // Filter
  console.log("collection scripts");
};

// Product scripts

productScripts = () => {
  console.log("product scripts");
  // reccs();
  productTabs();

  productScrollSnapCounter();

  var fixedFormCheck = document.querySelector(".js-fix-on-scroll");

  if (fixedFormCheck && !px800) {
    fixedAddToCart();
  } else if (fixedFormCheck && px800) {
    fixedAddToCartMobile();
  }

  if (!Shopify.designMode) {
    bridalHero();
  }
  bridalCarousel();
};

repeatScripts = () => {
  // console.log("repeat scripts");
  // Scripts that need to be re-run on window resize, infinite scroll etc.
};

universalScripts = () => {

  console.log("universal scripts");
  // Toggle Expanded
  let containers = document.querySelectorAll(".observed:has(.text--animate)");

  containers.forEach((container) => {
    scrollTriggerText(container);
  });

  intObs();


  if (indexCheck) {
    homeScrollSnapCounter();

    
    if (heroCarouselCheck && mq.matches) {
      homeHero();
      heroCarousel(heroCarouselEl);
    } else {
      if (homeFlkty) {
        homeFlkty.destroy();
      }
      homeFlkty = null;
    }

  }
  if (annBarCheck) {
    annBar();
  }

  mobileMenuClass(); 
  // Search Form
  let searchInput = document.querySelectorAll(".js-search-input");
  searchInput.forEach((search) => {
    new SearchForm(search);
  });

  // Search Modal
  let searchLinks = document.querySelectorAll(".js-search");
  searchLinks.forEach((link) => {
    onSearchClick(link);
  });
};

blogScripts = () => {
  // Infinite Scroll
  
  console.log("blog scripts");
  if (articleGrid) {
    // console.log("article grid");
    let latestArticleGrid = document.querySelector("#blog-grid");
    append = "li.article-card";
    infScroll(latestArticleGrid, append);
  }
};

// All Scripts
runScripts = () => {
  console.log("run scripts");
  universalScripts();
  
  if (productCheck) {
    productScripts();
  } else if (collectionCheck || searchCheck) {
    collectionScripts();
  } else if (blogCheck) {
    blogScripts();
  }
};

runScripts();

// Run scripts on window resize
window.addEventListener("resize", runScripts);
